'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _elementInView = require('@celsowhite/element-in-view');

var _elementInView2 = _interopRequireDefault(_elementInView);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*-------------------------------
Animate In View
---
Attach the class 'animate-in-view' to any element to trigger the 'animated' class when its in the users viewport.
Perform animations via CSS.
-------------------------------*/

document.addEventListener('DOMContentLoaded', function () {
  var animatedElements = document.querySelectorAll('.animate-in-view');

  // Check Animated Elements

  function checkAnimatedElements() {
    [].concat((0, _toConsumableArray3.default)(animatedElements)).forEach(function (elem) {
      var inView = (0, _elementInView2.default)(elem, 'top');
      var repeat = elem.dataset.repeat;
      // If in view then add the animated class.
      if (inView) {
        elem.classList.add('animated');
      }
      // Else if not in view and the animation should repeat then remove the animated class so it can be added again.
      else if (!inView && repeat) {
          elem.classList.remove('animated');
        }
    });
  }

  // Scroll Method

  window.addEventListener('scroll', (0, _debounce2.default)(checkAnimatedElements, 20));

  // Init

  checkAnimatedElements();
});